import Presence from './Presence';
import PresenceChange from './PresenceChange';

export interface RawPresenceChange {
	previous: { presence: boolean } | null;
	current: { presence: boolean } | null;
}

export default function mapPresenceChange(change: RawPresenceChange): PresenceChange {
	return new PresenceChange(
		change.previous !== null ? new Presence(change.previous.presence) : null,
		change.current !== null ? new Presence(change.current.presence) : null
	);
}
